import BaseComponent from 'source/lib/base_component';

import template from './template.html';

const LoginInfoBlock = BaseComponent.extend({
    name: 'login-info-block',
    template,
    events: {
        'click .js-login-info-back-link': 'backEventTrigger',
    },
    backEventTrigger() {
        this.components.proxyEvent('goback', {}, this);
        return false;
    },
});

export default LoginInfoBlock;
